export default "__VITE_ASSET__cf83f3d8__"